const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

export function toggleRecaptchaBadge(show: boolean) {
  const badge = document.querySelector('.grecaptcha-badge');
  if (!badge) return;

  if (show) badge.classList.remove('hiddenRecaptcha');
  else badge.classList.add('hiddenRecaptcha');
}

export function loadReCaptchaScript(): Promise<void> {
  return new Promise((resolve) => {
    if (document.getElementById('recaptcha-script')) {
      toggleRecaptchaBadge(true);
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`;
    script.async = true;

    script.onload = () => {
      const waitForReady = () => {
        if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
          window.grecaptcha.ready(() => {
            toggleRecaptchaBadge(true);
            resolve();
          });
        } else {
          let tries = 0;
          const interval = setInterval(() => {
            tries++;
            if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
              clearInterval(interval);
              window.grecaptcha.ready(() => {
                toggleRecaptchaBadge(true);
                resolve();
              });
            } else if (tries >= 50) {
              clearInterval(interval);
              console.warn('grecaptcha não inicializou após 5s');
              resolve();
            }
          }, 100);
        }
      };
      waitForReady();
    };

    document.body.appendChild(script);
  });
}

export function removeReCaptchaScript() {
  const script = document.getElementById('recaptcha-script');
  if (script) script.remove();

  if (window.grecaptcha) delete window.grecaptcha;
  if ((window as any).___grecaptcha_cfg) delete (window as any).___grecaptcha_cfg;

  document.querySelectorAll('iframe[src*="recaptcha"]').forEach((iframe) => iframe.remove());
  const badge = document.querySelector('.grecaptcha-badge');
  if (badge) badge.remove();
}

export const getReCaptchaToken = (action = 'default'): Promise<string> => {
  return new Promise((resolve, reject) => {
    const grecaptcha = window.grecaptcha;
    if (!grecaptcha) return reject('grecaptcha não disponível');

    grecaptcha.ready(() => {
      grecaptcha
        .execute(RECAPTCHA_KEY!, { action })
        .then(resolve)
        .catch(reject);
    });
  });
};
